<script>
import { UniqueId } from "../../../../utilities";

export default {
	name: "BaseFundCard",

	render() {
		return this.$scopedSlots.default({
			nameTruncated: this.nameTruncated,
			fundStats: this.fundStats
		});
	},

	props: {
		fundData: {
			type: Object
		}
	},

	computed: {
		nameTruncated() {
			if (this.fundData.name.length > 27) {
				return this.fundData.name.substring(0, 27) + "...";
			} else {
				return this.fundData.name;
			}
		},

		fundStats() {
			let fundStats = [];

			if (this.fundData.stats !== undefined) {
				// If stat is not an array, convert to array
				// for backward compatibility
				for (const stat of this.fundData.stats) {
					let statArr = [];

					stat.id = new UniqueId("stat-").generate();

					if (Array.isArray(stat)) {
						for (const statItem of stat) {
							const uniqueId = new UniqueId("stattab-").generate();
							statItem.id = uniqueId;
							statItem.slotName = `tab-pane-${uniqueId}`;
							statItem.title = statItem.label;
						}
						statArr = stat;
					} else {
						statArr.push(stat);
					}
					fundStats.push(statArr);
				}
			}

			return fundStats;
		}
	}
};
</script>

<style lang="scss">
.fund-card {
	@include commonBoxShadow;

	background: $color--white;
	color: $color--almost-black;
	display: flex !important;
	flex-direction: column;
	justify-content: space-between;
	margin-bottom: 20px;
	position: relative;
	top: 0;
	transition: top 0.2s ease, opacity 1s ease, transform 1.5s ease;

	@include from-md() {
		margin-right: 20px;
	}

	&:hover {
		top: -8px;
	}
}
</style>
